import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import about1 from "../assests/about1.png";
import about2 from "../assests/about2.png";
import about3 from "../assests/about3.png";
import about4 from "../assests/about4.png";

const AboutInfo = () => {
  return (
    <>
      <Box sx={{ padding: "60px 0", background: "#fff" }}>
        <Container maxWidth="xl">
          <Grid container spacing={2}>
            <Grid item size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <Box
                sx={{
                  "& img.aboutImgmain": {
                    display: "block",
                    maxWidth: "100%",
                  },
                }}
              >
                <img
                  src={about1}
                  alt="about-product"
                  className="aboutImgmain"
                />
              </Box>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 7, lg: 7 }}>
              <Typography
                className="titleSec"
                sx={{
                  textAlign: "center",
                }}
              >
                our story
              </Typography>
              <Typography
                sx={{
                  fontFamily: `"Lato", sans-serif`,
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontSize: "16px",
                  color: "#000",
                  textAlign: "left",
                  margin: "20px 0",
                }}
              >
                Lifeline was founded with a clear purpose: to strengthen the U.S. medical supply chain by building resilient, transparent, and cost-efficient bridges between American healthcare providers and trusted global manufacturers. Leveraging Jordan’s advanced manufacturing capabilities, we ensure a steady flow of high-quality medical products while reducing the burden of import duties and supply disruptions. Our work is grounded in integrity, ethical responsibility, and a commitment to improving healthcare access for all.
              </Typography>
              <Grid container spacing={2}>
                <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
                  <Box
                    sx={{
                      background: "#C1EAD7",
                      borderRadius: "19px",
                      height: "339px",
                      display: "flex",
                      alignItems: "center",
                      "& img.aboutimg2": {
                        display: "block",
                        maxWidth: "100%",
                      },
                    }}
                  >
                    <img
                      src={about2}
                      alt="about-product"
                      className="aboutimg2"
                    />
                  </Box>
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
                  <Box
                    sx={{
                      background: "#E3E3E3",
                      borderRadius: "19px",
                      height: "339px",
                      display: "flex",
                      alignItems: "center",
                      "& img.aboutimg3": {
                        display: "block",
                        maxWidth: "100%",
                      },
                    }}
                  >
                    <img
                      src={about3}
                      alt="about-product"
                      className="aboutimg3"
                    />
                  </Box>
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 4 }}>
                  <Box
                    sx={{
                      background: "#FFECBE",
                      borderRadius: "19px",
                      height: "339px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      "& img.aboutimg4": {
                        display: "block",
                        maxWidth: "100%",
                      },
                    }}
                  >
                    <img
                      src={about4}
                      alt="about-product"
                      className="aboutimg4"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default AboutInfo;
